import React from 'react';
import Mark from './Mark';
export default function MinuteMark(props) {
  return /*#__PURE__*/React.createElement(Mark, props);
}